// extracted by mini-css-extract-plugin
export default {"wrapper":"GetIcon_wrapper__otr1I"};